import { motion } from "framer-motion";
import { MapPin, Globe2, Building2 } from "lucide-react";

const HUBS = ["United States", "United Kingdom", "United Arab Emirates", "Australia", "Canada"];

const IMG =
  "https://images.pexels.com/photos/4864249/pexels-photo-4864249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Coverage = () => (
  <section id="coverage" data-testid="coverage-section" className="relative py-28 lg:py-36 overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.07] bg-cover bg-center saturate-0"
      style={{ backgroundImage: `url(${IMG})` }}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-ark-950 via-ark-950/80 to-ark-950" aria-hidden="true" />

    <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
        className="lg:col-span-5"
      >
        <p className="font-mono text-xs tracking-[0.3em] text-cyan-400 uppercase font-semibold">
          04 // Coverage
        </p>
        <h2 className="mt-4 font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-slate-100">
          Pan-India Operations, <span className="metallic-text">Global Remote Reach</span>
        </h2>
        <p className="mt-5 text-base text-slate-400 leading-relaxed">
          On-site dispatch and deployment capability across all major tier-1 and tier-2
          Indian metro hubs — backed by round-the-clock remote engineering for
          international clients.
        </p>

        <div
          data-testid="coverage-hq-card"
          className="mt-10 p-6 rounded-2xl border border-white/10 bg-ark-800/70 backdrop-blur-sm hover:border-cyan-400/30 transition-colors duration-300"
        >
          <div className="flex items-center gap-3">
            <Building2 size={18} className="text-cyan-400" />
            <h3 className="font-display font-semibold text-lg text-white">Headquarters</h3>
          </div>
          <p className="mt-3 flex items-start gap-2.5 text-sm text-slate-400 leading-relaxed">
            <MapPin size={15} className="mt-0.5 shrink-0 text-cyan-400/70" />
            Menz House, Ground Floor, Sector-11, Juhu Village, Vashi, Thane,
            Navi Mumbai, Maharashtra 400703
          </p>
        </div>
      </motion.div>

      <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 content-start">
        {HUBS.map((hub, i) => (
          <motion.div
            key={hub}
            data-testid={`coverage-hub-${hub.toLowerCase().replace(/\s/g, "-")}`}
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="group p-6 rounded-2xl border border-white/10 bg-ark-800/50 backdrop-blur-sm hover:bg-ark-700/60 hover:border-cyan-400/40 hover:shadow-[0_0_25px_rgba(56,189,248,0.12)] hover:scale-[1.02] transition-all duration-300"
          >
            <Globe2 size={20} className="text-cyan-400/70 group-hover:text-cyan-300 transition-colors" />
            <h3 className="mt-4 font-display font-semibold text-lg text-white">{hub}</h3>
            <p className="mt-1 font-mono text-[11px] tracking-[0.2em] text-slate-500 uppercase">
              Remote Support Hub
            </p>
          </motion.div>
        ))}
        <motion.div
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="p-6 rounded-2xl border border-cyan-400/30 bg-gradient-to-br from-cyan-400/10 to-transparent"
        >
          <p className="font-display text-3xl font-bold metallic-text">Pan-India</p>
          <p className="mt-2 text-sm text-slate-400">
            Every metro. Every tier. On-site, on time.
          </p>
        </motion.div>
      </div>
    </div>
  </section>
);
